import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdmin } from '../../hooks/useAdmin';

const AdminRedirect: React.FC = () => {
  const navigate = useNavigate();
  const { isAdmin } = useAdmin();

  useEffect(() => {
    navigate(isAdmin ? '/admin/panel' : '/admin/auth');
  }, [isAdmin, navigate]);

  return null;
};

export default AdminRedirect; 